import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/service/auth.service';
import { info, confirm, warn, error } from '@elf/amber-notification/lib/helpers';
import { ClientEventType, PubSubService } from 'src/service/pub-sub.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private router:Router, private authService: AuthService, private pubSubService: PubSubService ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      //console.log(route)
      //console.log(state)
      //return true;
    if (this.authService.isAdmin()) {
      return true;
    } else {
      this.router.navigate(["/main"])
      this.pubSubService.publishClientEvent(ClientEventType.showLoginDialog);
      // don't make any warning
      return false;
    }
  }

}
